import script from "./MatrixEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatrixEditForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__